import { ACTIVE_FLAGS } from '../init';
export const setFeatureFlag = (key, value) => {
    if (!ACTIVE_FLAGS)
        return;
    ACTIVE_FLAGS[key] = value;
};
